export default __webpack_public_path__ + "static/media/YOOZ-3ds2_.a8e3c394.png";